export default {"src":"/_next/static/media/ic-tiktok.7395c857.svg","height":32,"width":32};